import React from "react";
import { useTranslation } from 'react-i18next'; // Import useTranslation
import './Movement.css';

import { MovementScreenData } from "../../types/movement.type";

interface HorMovementProps {
  movementScreenData?: MovementScreenData;
}

export const HorMovement: React.FC<HorMovementProps> = ({ movementScreenData }): JSX.Element => {

  const { t } = useTranslation(); // Use the hook

  const truncate_description = (description: string | undefined): string => {
    return description ? (description.length > 600 ? description.slice(0, 600) + "..." : description) : "";
  }
 
  if (!movementScreenData) {
    return (
      <div className="mov-movement-horizontal-wrapper">
        <div className="mov-container-wrapper">
          <div className="mov-container">
            <div className="mov-content">
              <div className="mov-text-wrapper">{t("Loading")}</div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mov-movement-horizontal-wrapper">
        <div className="mov-container-wrapper">
          <div className="mov-container">
            <div className="mov-content">
              <div className="mov-div">
                <div className="mov-icon">
                  <img className="mov-img-2" alt="Route" src="/img/flag.svg" />
                </div>
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.stations}</div>
                  <div className="mov-text-wrapper">{t("stations")}</div>
                </div>
              </div>
              <div className="mov-div">
                <div className="mov-icon">
                  <img className="mov-img-2" alt="Route" src="/img/refresh.svg" />
                </div>
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.totalSets}</div>
                  <div className="mov-text-wrapper">{t("sets")}</div>
                </div>
              </div>
              <div className="mov-div">
                <div className="mov-icon">
                  <img className="mov-img-2" alt="Route" src="/img/cycle.svg" />
                </div>
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.pods}</div>
                  <div className="mov-text-wrapper">{t("pods")}</div>
                </div>
              </div>
              <div className="mov-div">
                <div className="mov-icon">
                  <img className="mov-img-2" alt="Route" src="/img/hidration.svg" />
                </div>
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.hydrations && movementScreenData.hydrations > 0
                    ? movementScreenData.hydrations
                    : '-'}</div>
                  <div className="mov-text-wrapper">{t("hydration")}</div>
                </div>
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.hydrations && movementScreenData.hydrations > 0
                    ? `${movementScreenData.hydrationTime} s`
                    : '-'} </div>
                  <div className="mov-text-wrapper">{t("rest")}</div>
                </div>
              </div>
              <div className="mov-div">
                <img className="mov-img-2" alt="Timer reset" src="/img/timer.svg" />
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.exerciseTime} s</div>
                  <div className="mov-text-wrapper">{t("exercise")}</div>
                </div>
                <div className="mov-text">
                  <div className="mov-text-2">{movementScreenData.restTime} s</div>
                  <div className="mov-text-wrapper">{t("rest")}</div>
                </div>
              </div>
            </div>
            <div className="mov-movement">
              <div className="workout-icon-container">
                <img className="mov-workout-image" alt="Container" src={movementScreenData.workoutImage} />
              </div>
              <div className="mov-text-title">{movementScreenData.name}</div>
              <div className="mov-text-description"> {truncate_description(movementScreenData.description)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};